<div class="w-[600px]">
	<div class="border-b-2 -ml-24 -mr-24">
		<div class="flex justify-between mb-4 ml-24">
			<span class="text-xl">How to Manage Accounting Codes in LEAP</span>
		</div>
	</div>

	<mat-dialog-content class="border-b-2">
		<div class="mb-8">
			<div class="text-xl mb-4">
				Step 1: Open LEAP's menu, and select "Settings".
			</div>

			<img class="w-[409px]" src="/assets/images/leap/soa-1.png" />
		</div>
		<div class="mb-8">
			<div class="text-xl mb-4">
				Step 2: Under "Firm & Application Settings", select "Application
				Settings".
			</div>

			<img class="w-[409px]" src="/assets/images/leap/soa-2.png" />
		</div>
		<div class="mb-8">
			<div class="text-xl mb-4">
				Step 3: Under the "Accounting" tab, navigate to "Activity Codes", and
				select either "Time & Fees" or "Expense Recovery".
			</div>

			<img class="w-[409px]" src="/assets/images/leap/soa-3.png" />
		</div>
		<div class="mb-8">
			<div class="text-xl mb-4">
				Step 4: Add, edit, or remove Activity Codes as needed.
			</div>

			<img class="w-[409px]" src="/assets/images/leap/soa-4.png" />
		</div>
		<div class="mb-8">
			<div class="text-xl mb-4">
				Step 5: Return to Closer, and click the "Import" button to refresh your
				accounting codes.
			</div>

			<img class="w-[409px]" src="/assets/images/leap/soa-5.png" />
		</div>
	</mat-dialog-content>
	<mat-dialog-actions>
		<div class="w-full ml-24">
			<div class="flex justify-end">
				<ui-button label="Close" mat-dialog-close></ui-button>
			</div>
		</div>
	</mat-dialog-actions>
</div>
